import { useEffect } from "react";
import styled from "styled-components";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MenuBar from "../components/MenuComponents/MenuBar";
import TermsContent from "../components/Modal/TermsContent";
import { colors } from "../res/values/values";

const Container = styled.div``;
const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: white;
`;
const Title = styled.h1`
  color: ${colors.blackColor};
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e5e5;
`;
const Content = styled.div`
  font-size: 14px;
  line-height: 1.7;
  color: #333;
  & p {
    margin-bottom: 16px;
  }
`;

const Terms = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Container>
      <Header />
      <Wrapper>
        <Title>TRADING TERMS & CONDITIONS</Title>
        <Content>
          <TermsContent />
        </Content>
      </Wrapper>
      <Footer />
    </Container>
  );
};

export default Terms;
